import React from "react";
import { useTranslation } from "react-i18next";

import {
  useEditAccessRestrictions,
  useRetrieveAccessRestrictions,
  useRetrieveCurrentPlanzone,
  useRetrievePlanzoneSettings,
} from "@planzone/view-models";
import { RestrictedAreas } from "@planzone/dto";
import { Props } from "./types";
import { RoleSelection } from "./roleSelection";
import styles from "./styles.scss";

const restrictedAreas: RestrictedAreas[] = [
  "personalSynthesis",
  "personalTimesheet",
  "resources",
  "costProfiles",
  "capacity",
  "workload",
  "occupancy",
  "projectTemplates",
  "projectReportsTemplate",
  "projectStatuses",
  "secondaryCriteriaTemplate",
  "strategicAxes",
  "portfolios",
  "calendar",
  "documents",
  "exports",
  "onlyOffice",
];

function AccessRestrictionsEdition(props: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { settings } = useRetrievePlanzoneSettings(planzone);
  const { accessRestrictions } = useRetrieveAccessRestrictions();
  const { editAccessRestrictions } = useEditAccessRestrictions();

  return (
    <div className={styles.accessRestrictionsEdition}>
      {restrictedAreas
        .filter(
          (area) => !(!settings.canUseOnlyOffice && area === "onlyOffice"),
        )
        .map((area) => (
          <div key={area} className={styles.area}>
            <div className={styles.col}>
              <p className={styles.name}>
                {t(`accessRestrictionsEdition.${area}`)}
              </p>
            </div>
            <div className={styles.col}>
              <div className={styles.roleSelection}>
                <RoleSelection
                  selectedRoleIds={accessRestrictions[area]}
                  select={(role) =>
                    editAccessRestrictions({
                      planzone,
                      restrictions: accessRestrictions,
                      nextRestrictions: {
                        ...accessRestrictions,
                        [area]: [...accessRestrictions[area], role.name].filter(
                          (name) => !!name,
                        ),
                      },
                    })
                  }
                  unSelect={(role) =>
                    editAccessRestrictions({
                      planzone,
                      restrictions: accessRestrictions,
                      nextRestrictions: {
                        ...accessRestrictions,
                        [area]: accessRestrictions[area].filter(
                          (id) => id !== role.uuid && id !== role.name,
                        ),
                      },
                    })
                  }
                />
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}

export { AccessRestrictionsEdition };
